import {baseApi} from "./base-api";

export const reportApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getWorkOrderReport: builder.query<ReportResponse, string>({
      query: (workOrderId) => ({
        url: `reports/exportWorkOrder`,
        method: 'GET',
        params: {
          workOrderId
        },
      })
    }),
    getWorkOrderReportsZip: builder.mutation<ReportResponse, { workOrderIds: string[] }>({
      query: ({ workOrderIds }) => ({
        url: `reports/exportWorkOrdersZip`,
        method: "POST",
        body: {
          workOrderIds
        },
      }),
    }),
    emailWorkOrders: builder.mutation<void, { workOrderIds: string[]; email: string }>({
      query: ({ workOrderIds, email }) => ({
        url: `reports/emailWorkOrderReports`,
        method: "POST",
        body: {
          workOrderIds,
          email,
        },
      }),
    }),
  }),
  overrideExisting: false,
});

export interface ReportResponse {
  fileName: string;
  reportData: string;
}

export const {
  useLazyGetWorkOrderReportQuery,
  useEmailWorkOrdersMutation,
  useGetWorkOrderReportsZipMutation
} = reportApi;
